// Subscribes to the AdminChannel and invokes a callback whenever an
// operational event fires (ticketing_grant_success/failed,
// stripe_polling_started/stalled, pending_count_changed). Every event goes to
// every subscriber, so callers check `data.event` for the ones they care about.
// Pass enabled=false for non-SuperAdmins so no cable connection is opened
// (the server would reject the subscription anyway).
import { useEffect } from 'react';
import { getCable } from '../cable';

export interface AdminChannelEvent {
  event:
    | 'ticketing_grant_success'
    | 'ticketing_grant_failed'
    | 'stripe_polling_started'
    | 'stripe_polling_stalled'
    | 'pending_count_changed';
  user_id?: number;
  username?: string;
  error?: string;
  started_at?: string;
  count?: number;
}

export function useAdminChannel(onEvent: (data: AdminChannelEvent) => void, enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;

    const cable = getCable();
    const subscription = cable.subscriptions.create(
      { channel: 'AdminChannel' },
      {
        received(data: AdminChannelEvent) {
          onEvent(data);
        },
      },
    );
    return () => {
      subscription.unsubscribe();
    };
  }, [onEvent, enabled]);
}
